import { render, staticRenderFns } from "./SelfTestPelletizingGriEdit.vue?vue&type=template&id=6c983228&"
import script from "./SelfTestPelletizingGriEdit.vue?vue&type=script&lang=js&"
export * from "./SelfTestPelletizingGriEdit.vue?vue&type=script&lang=js&"
import style0 from "./SelfTestPelletizingGriEdit.vue?vue&type=style&index=0&id=6c983228&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports